import { render } from "./온라인증명서발급.vue?vue&type=template&id=0404c2c2"
import script from "./온라인증명서발급.vue?vue&type=script&lang=js"
export * from "./온라인증명서발급.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__